import { Outlet, useLocation } from 'react-router-dom'
import { CheckoutBar } from '../components/CheckoutBar'
import { Footer } from '../components/Footer'
import { SiteActions } from '../components/SiteActions'
import { Header } from '../components/Header'
import { LocationModal } from '../components/LocationModal'
import { isCheckoutRoute } from '../helpers/checkout'
import { AuthProvider } from '../hooks/useAuth'
import { CartProvider } from '../hooks/useCart'
import { DeliveryLocationProvider } from '../hooks/useDeliveryLocation'
import { useCheckoutLocationLock } from '../hooks/useCheckoutLocationLock'
import { useScrollToTop } from '../hooks/useScrollToTop'
import { WishlistProvider } from '../hooks/useWishlist'

function CheckoutLocationLock() {
  useCheckoutLocationLock()
  return null
}

export function MainLayout() {
  useScrollToTop()
  const { pathname } = useLocation()
  const checkout = isCheckoutRoute(pathname)

  return (
    <AuthProvider>
      <DeliveryLocationProvider>
        <CartProvider>
          <WishlistProvider>
            <CheckoutLocationLock />
            {checkout ? <CheckoutBar /> : <Header />}
            <main className="page-main">
              <Outlet />
            </main>
            {checkout ? null : <Footer />}
            {checkout ? null : <SiteActions />}
            <LocationModal />
          </WishlistProvider>
        </CartProvider>
      </DeliveryLocationProvider>
    </AuthProvider>
  )
}
